export const API_URL = process.env.REACT_APP_API_URL as string;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL as string;


export const DOCUMENT_TITLE = {
    login : 'Login | Zawaj Sounnah',
}

